import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Header, Grid, Divider, Flag, Popup, Icon } from 'semantic-ui-react';
import cn from 'classnames';
import {
  Accounts,
  Portfolio,
  Storage,
  ReallocateAccount,
  HoldingsConcentration,
  StockExposure,
} from 'actions';
import { colors } from 'utils/colors';
import {
  notWealthica,
  hasNegativeWeight,
  getHoldTotalMarketValue,
} from 'utils/helpers';
import { Segment, ButtonFilled, Feature } from 'components';
// import { ACCOUNTS_ADDITIONAL_FEATURES } from 'utils/features';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faSync,
  faMagnifyingGlassDollar,
  // eslint-disable-next-line import/extensions
} from '@fortawesome/free-solid-svg-icons';

import { HoldingTable, GicTable, AssetChart } from '../components';
import { translation } from '../../Translation/accounts';
import { hasCurrencyOptions } from '../../../utils/helpers';

class MultipleAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tablePage: 1,
    };
  }

  componentDidMount() {
    const { selectedAccountList, history } = this.props;

    if (selectedAccountList.length === 0) {
      history.push('/accounts/user');
    }
  }

  getFlag = (currency) => (currency === 'USD' ? 'us' : 'ca');

  analyze = (holdings, region) => {
    const { dispatch, history, selectedAccountList } = this.props;
    const gicHoldings = holdings.filter((holding) => holding.gic_ticker);
    Storage.removeItem('pwpa-has-exclude-holding');

    const concatAccountNames = selectedAccountList
      .map((acc) => acc.user_institution)
      .join(' - ');
    return dispatch(
      Accounts.analyze(
        holdings,
        history,
        { user_institution: concatAccountNames },
        gicHoldings,
        region
      )
    );
  };

  parseNum = (num) => {
    num = !num ? 0 : Math.round(num * 100) / 100;
    return num.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  increaseTablePage = () => {
    const { tablePage } = this.state;
    this.setState({ tablePage: tablePage + 1 });
  };

  decreaseTablePage = () => {
    const { tablePage } = this.state;
    this.setState({ tablePage: tablePage - 1 });
  };

  render() {
    const {
      dispatch,
      history,
      selectedAccountOverview,
      selectedAccountList,
      pwpaExchangeRate,
      user_region,
      partnerName,
      french,
      language,
    } = this.props;
    const { tablePage } = this.state;
    const validHoldings =
      selectedAccountOverview !== null
        ? selectedAccountOverview.holdings.filter(
            (holding) => !!holding.security_detail
          )
        : null;
    const usdHolding = validHoldings.find((holding) => {
      const price = holding.security_detail
        ? holding.security_detail.unadjusted_closing_price.USD
        : holding.unadjusted_closing_price.USD;

      return holding.default_currency === 'USD' && !!price;
    });
    const usdAccount = selectedAccountList.find(
      (account) => account.currency === 'USD'
    );
    const excludeGicHoldings =
      selectedAccountOverview &&
      selectedAccountOverview.holdings.filter((holding) => !holding.gic_ticker);
    const gicHoldings =
      selectedAccountOverview &&
      selectedAccountOverview.holdings.filter((holding) => holding.gic_ticker);
    const hasNegativeWeights = hasNegativeWeight(
      selectedAccountOverview.holdings
    );
    const isNegativePort =
      getHoldTotalMarketValue(
        selectedAccountOverview,
        pwpaExchangeRate,
        user_region
      ) < 0;

    return (
      <div>
        {selectedAccountOverview !== null &&
          selectedAccountList.length !== 0 && (
            <Segment>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <Header
                    size="large"
                    content={french ? 'Comptes groupés' : 'Grouped Accounts'}
                    subheader={`${selectedAccountList.length} ${
                      french ? 'comptes sélectionnés' : 'accounts selected'
                    }`}
                  />
                  {hasNegativeWeights ? (
                    isNegativePort ? (
                      <p
                        style={{
                          color: `${colors.red}`,
                          fontWeight: 'bold',
                        }}
                      >
                        <Icon name="warning sign" style={{}} />
                        {translation[language].WARNING_NEGATIVEPORT}
                      </p>
                    ) : (
                      <p
                        style={{
                          color: `${colors.red}`,
                          fontWeight: 'bold',
                        }}
                      >
                        <Icon name="warning sign" style={{}} />
                        {translation[language].WARNING_SHORTPOSITIONS}
                      </p>
                    )
                  ) : null}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column' }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'end',
                    }}
                  >
                    <CurrencyOption>
                      <ButtonFilled
                        className={cn('left', {
                          disabled: isNegativePort,
                        })}
                        icon="line chart"
                        color={colors.darkBlue}
                        onClick={() => {
                          if (
                            !hasCurrencyOptions(
                              user_region,
                              selectedAccountOverview.currency
                            )
                          ) {
                            this.analyze(
                              selectedAccountOverview.holdings,
                              user_region
                            );
                            dispatch(
                              Storage.setItem('toggle_region', user_region)
                            );
                            dispatch(Portfolio.notSaveUrlSc());
                          }
                        }}
                        style={{ zIndex: 1 }}
                      >
                        {french ? 'Analyser' : 'Analyze'}
                      </ButtonFilled>
                      {!isNegativePort && (
                        <div
                          className="currency_item"
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: 'white',
                          }}
                        >
                          {!isNegativePort &&
                            hasCurrencyOptions(
                              user_region,
                              selectedAccountOverview.currency
                            ) && (
                              <span>
                                <StyledButton
                                  className="basic"
                                  color={colors.darkBlue}
                                  onClick={() => {
                                    this.analyze(
                                      selectedAccountOverview.holdings,
                                      'US'
                                    );
                                    dispatch(
                                      Storage.setItem('toggle_region', 'US')
                                    );
                                    dispatch(Portfolio.notSaveUrlSc());
                                  }}
                                >
                                  <div className="flag">
                                    <Flag
                                      name="us"
                                      style={{ height: 'inherit' }}
                                    />
                                  </div>
                                  <div style={{ marginLeft: '36px' }}>
                                    {french ? 'En USD' : 'In USD'}
                                  </div>
                                </StyledButton>
                                <StyledButton
                                  className="basic"
                                  color={colors.darkBlue}
                                  onClick={() => {
                                    this.analyze(
                                      selectedAccountOverview.holdings,
                                      'CA'
                                    );
                                    dispatch(
                                      Storage.setItem('toggle_region', 'CA')
                                    );
                                    dispatch(Portfolio.notSaveUrlSc());
                                  }}
                                >
                                  <div className="flag">
                                    <Flag
                                      name="ca"
                                      style={{ height: 'inherit' }}
                                    />
                                  </div>
                                  <div style={{ marginLeft: '36px' }}>
                                    {french ? 'En CAD' : 'In CAD'}
                                  </div>
                                </StyledButton>
                              </span>
                            )}
                          {selectedAccountOverview.cash > 0 && (
                            <StyledButton
                              className="basic"
                              color={colors.darkBlue}
                              onClick={() =>
                                history.push('/accounts/multiple/cash')
                              }
                            >
                              <div className="flag cash">
                                <Icon
                                  name="money"
                                  style={{ fontSize: '1rem', margin: '0' }}
                                />
                              </div>
                              <div style={{ marginLeft: '36px' }}>
                                {french ? 'Argent liquide' : 'Incl. Cash'}
                              </div>
                            </StyledButton>
                          )}
                        </div>
                      )}
                    </CurrencyOption>
                  </div>
                  {/* <Feature name={ACCOUNTS_ADDITIONAL_FEATURES}> */}
                  <MoreActions>
                    <IconPill
                      color={colors.teal}
                      onClick={() => {
                        dispatch(ReallocateAccount.resetReallocate());
                        dispatch(
                          ReallocateAccount.updateParameter('selectedAccount', [
                            ...selectedAccountList,
                          ])
                        );
                        dispatch(
                          ReallocateAccount.updateParameter('currentPage', 1)
                        );
                        history.push(`/tools/portfolio-reallocate`);
                      }}
                    >
                      <FontAwesomeIcon icon={faSync} />
                      <IconPillLabel>Reallocate</IconPillLabel>
                    </IconPill>
                    <IconPill
                      color={colors.purple}
                      onClick={() => {
                        dispatch(HoldingsConcentration.clear());
                        dispatch(
                          HoldingsConcentration.setSelectedAccounts(
                            selectedAccountList.map((acc) => acc.id)
                          )
                        );
                        history.push(`/tools/holdings-concentration`);
                      }}
                    >
                      <Icon name="chart pie" />
                      <IconPillLabel>Stock Concentration</IconPillLabel>
                    </IconPill>
                    <IconPill
                      color={colors.red}
                      onClick={() => {
                        dispatch(StockExposure.clear());
                        dispatch(
                          StockExposure.setSelectedAccounts(
                            selectedAccountList.map((acc) => acc.id)
                          )
                        );
                        history.push(`/tools/stock-exposure`);
                      }}
                    >
                      <FontAwesomeIcon icon={faMagnifyingGlassDollar} />
                      <IconPillLabel>Stock Exposure</IconPillLabel>
                    </IconPill>
                  </MoreActions>
                  {/* </Feature> */}
                </div>
              </div>
              <Divider fitted />
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column width={7}>
                    <div style={{ marginTop: '1.3rem' }}>
                      <div style={{ float: 'left', padding: '0 2rem 1rem 0' }}>
                        <Header
                          size="medium"
                          content={
                            french ? 'Valeur du Compte' : 'Account Value:'
                          }
                          sub
                          style={{ margin: 0, fontWeight: 700 }}
                        />
                        <Value className="main">
                          {`$${this.parseNum(selectedAccountOverview.balance)}`}
                          <Flag
                            name={this.getFlag(
                              selectedAccountOverview.currency
                            )}
                            style={{
                              position: 'relative',
                              bottom: '7px',
                              marginLeft: 7,
                            }}
                          />
                        </Value>
                      </div>

                      <div style={{ float: 'left', padding: '0 0 1rem 0' }}>
                        <Header
                          size="medium"
                          content={
                            french ? 'Variation quotidienne' : 'Daily Change:'
                          }
                          sub
                          style={{ margin: 0 }}
                        />
                        <Value>{`${
                          selectedAccountOverview.change || 0
                        }%`}</Value>
                      </div>
                    </div>

                    <div style={{ clear: 'both' }}>
                      <Header
                        size="medium"
                        content={
                          french
                            ? 'Valeur totale des avoirs'
                            : 'Holdings Value:'
                        }
                        sub
                        style={{ margin: 0 }}
                      />
                      <Value>{`$${this.parseNum(
                        selectedAccountOverview.balance -
                          selectedAccountOverview.cash
                      )}`}</Value>
                    </div>
                    <div style={{ marginTop: '1.3rem' }}>
                      <Header
                        sub
                        size="medium"
                        style={{ margin: 0 }}
                        content={
                          <div>
                            {french ? 'Valeur en espèces' : 'Cash value:'}
                          </div>
                        }
                      />
                      <Value>{`$${this.parseNum(
                        selectedAccountOverview.cash
                      )}`}</Value>
                    </div>
                  </Grid.Column>
                  <Grid.Column width={9}>
                    {!selectedAccountOverview.holdings.length ||
                    !validHoldings.length ? null : (
                      <Segment basic compact>
                        <Header
                          size="medium"
                          textAlign="center"
                          style={{ margin: '0 0 1rem 0' }}
                        >
                          {french
                            ? 'Répartition nette de l’actif'
                            : 'Net Asset Allocation'}
                          <Header.Subheader>
                            {french
                              ? 'Comprend les positions sous-jacentes des fonds équilibrés et des fonds de répartition d’actifs.'
                              : 'Includes a breakdown of the underlying holdings of balanced and asset allocation funds.'}
                            <Popup
                              trigger={
                                <Icon
                                  name="question circle outline"
                                  style={{
                                    fontSize: '15px',
                                    verticalAlign: 'initial',
                                    color: 'dimgrey',
                                  }}
                                />
                              }
                              position="top center"
                              content={
                                french
                                  ? 'Analysez et utilisez le Scorecard pour approfondir les positions sous-jacentes afin de i) voir la répartition géographique par catégorie d’actif, et ii) vérifier la structure des fonds (p. ex., certains fonds utilisent des produits dérivés). Vous trouverez cette information dans Diversification → Catégorie d’actif (graphique du bas).'
                                  : 'Analyze and use the Scorecard to drill down to the underlying holdings to i) see the geographical split by asset class, and ii) check fund structure (e.g., some funds use derivatives). You will find this information in Diversification → Asset Class (bottom chart).'
                              }
                              wide
                            />
                          </Header.Subheader>
                        </Header>
                        <AssetChart
                          accounts={selectedAccountList}
                          overview={selectedAccountOverview}
                        />
                      </Segment>
                    )}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <div style={{ clear: 'both' }} />

              {!notWealthica(partnerName) && (
                <p
                  style={{
                    fontWeight: 'bold',
                    position: 'absolute',
                    right: '7rem',
                    transform: 'translateY(2rem)',
                  }}
                >
                  {tablePage} {french ? 'sur' : 'of'} 2
                </p>
              )}

              <HoldingTable
                accountList={selectedAccountList}
                totalMarketValue={
                  selectedAccountOverview.balance - selectedAccountOverview.cash
                }
                holdings={excludeGicHoldings.slice(0, 10)}
                accountName=""
                title={
                  french ? 'Vos 10 plus grandes positions' : 'Top 10 Holdings'
                }
                isCombined
                increaseTablePage={this.increaseTablePage}
                decreaseTablePage={this.decreaseTablePage}
              />
              <GicTable
                user_region={user_region}
                gicHoldings={gicHoldings}
                totalMarketValue={
                  selectedAccountOverview.balance - selectedAccountOverview.cash
                }
                title="GIC"
                rate={pwpaExchangeRate}
              />
              {excludeGicHoldings.length !== 0 && (
                <P>
                  {user_region === 'CA' ? (
                    // eslint-disable-next-line react/jsx-fragments
                    <React.Fragment>
                      {selectedAccountOverview.currency === 'CAD'
                        ? french
                          ? 'Actuellement, nous disposons de données sur les actions/ETF canadiens et américains, les fonds communs de placement et les fonds séparés canadiens, ainsi que les fonds HISA en CAD/USD.'
                          : 'Currently, we have data for Canadian and US stocks/ETFs, Canadian mutual and segregated funds, and CAD/USD HISA funds.'
                        : french
                        ? 'Pour les comptes en dollars US, nous n’avons de données que pour les actions et FNB inscrits aux États-Unis, les fonds communs américains et les titres inscrits au Canada mais libellés en dollars US.'
                        : 'For USD accounts, we only have data for U.S.-listed stocks/ETFs, U.S. mutual funds, and Canadian-listed securities denominated in USD.'}
                      {user_region === 'CA' &&
                        selectedAccountOverview.currency === 'CAD' && (
                          <Popup
                            trigger={
                              <Icon
                                name="question circle outline"
                                style={{
                                  fontSize: '15px',
                                  verticalAlign: 'initial',
                                }}
                              />
                            }
                            content={
                              french
                                ? 'Les fonds de CÉIÉ en CAD/USD sont inclus dans l’analyse en utilisant le rendement historique d’un fonds de CÉIÉ en CAD/USD représentatif détenu par une banque.'
                                : 'CAD/USD HISA funds are included in the analysis using the historical rates of a representative bank-owned CAD/USD HISA fund.'
                            }
                            position="top center"
                          />
                        )}
                      <br />
                      {french ? (
                        'Toute autre valeur mobilière sera exclue de l’analyse.'
                      ) : (
                        // eslint-disable-next-line react/jsx-fragments
                        <React.Fragment>
                          Any other securities such as{' '}
                          <b>
                            private funds, individual bonds, and derivatives
                          </b>{' '}
                          will be excluded from the analysis.
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ) : (
                    'Currently we only have data for U.S. listed stocks and ETFs, U.S. mutual funds, Bitcoin, and Ethereum. Any other security will be excluded from the analysis.'
                  )}
                </P>
              )}
              {(!!usdHolding || !!usdAccount) &&
                excludeGicHoldings.length !== 0 && (
                  <P>
                    {french
                      ? 'Le taux de change USD/CAD utilisé est de '
                      : 'USD/CAD exchange rate used is '}
                    {pwpaExchangeRate || 1.3}
                  </P>
                )}
            </Segment>
          )}
      </div>
    );
  }
}

MultipleAccount.propTypes = {
  dispatch: PropTypes.func,
  history: PropTypes.object,
  selectedAccountList: PropTypes.array,
  selectedAccountOverview: PropTypes.object,
  pwpaExchangeRate: PropTypes.number,
  user_region: PropTypes.string,
  partnerName: PropTypes.string,
  french: PropTypes.bool,
  language: PropTypes.string,
};

MultipleAccount.defaultProps = {
  dispatch: () => {},
  history: {},
  selectedAccountOverview: {},
  selectedAccountList: [],
  pwpaExchangeRate: 0,
  user_region: 'CA',
  partnerName: '',
  french: false,
  language: 'en',
};

export default connect((state) => ({
  selectedAccountList: state.Accounts.selectedAccountList,
  selectedAccountOverview: state.Accounts.selectedAccountOverview,
  pwpaExchangeRate: state.Storage['pwpa-exchange-rate'],
  user_region: state.Storage.user_region,
  partnerName: state.Storage['partner-name'],
  french: state.Storage.language === 'fr',
  language: state.Storage.language,
}))(MultipleAccount);

const Value = styled.div`
  font-size: 1.8rem;
  padding: 7px 0;

  &.main {
    font-size: 2.4rem;
    font-weight: 700;
    color: ${colors.orange};
  }
`;

const MoreActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: end;
  margin: 1rem 0;
`;

const CurrencyOption = styled.div`
  z-index: 3;
  cursor: pointer;
  &:hover {
    & .currency_item {
      opacity: 1;
      visibility: visible;
      top: 68px;
      transition: opacity 200ms ease, top 150ms ease;
    }
  }
  .currency_item {
    opacity: 0;
    visibility: hidden;
    position: absolute;
    top: 68px;
  }
`;

const StyledButton = styled.div`
  position: relative;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(34, 36, 38, 0.15) inset;
  font-size: 0.9rem;
  display: inline-block;
  min-height: 1em;
  min-width: 129px;
  height: 36px;
  border: none;
  text-align: center;
  outline: 0;
  transition: all 0.3s ease;
  overflow: hidden;
  color: white;
  background-color: ${colors.darkBlue};
  vertical-align: top;
  line-height: 36px !important;
  user-select: none !important;
  margin-top: 5px !important;
  &:hover {
    box-shadow: inset 0 0 0 1.5px ${colors.darkBlue} !important;
    opacity: 0.8;
  }
  .flag {
    height: 100%;
    position: absolute;
    color: white;
    top: 0;
    width: 36px;
    background-color: ${colors.darkBlue};
    padding-right: 36px;
    &:before {
      position: absolute;
      line-height: 1;
      font-size: 1em;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .cash {
    padding-right: 0px;
  }
`;

const IconPillLabel = styled.span`
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  opacity: 1;
  font-size: 14px;
  font-weight: 400;
  padding-right: 0;
  color: ${colors.darkGrey};
`;

const IconPill = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 5px 14px 5px 8px;
  background: white;
  border: 1px solid #dededf;
  min-width: 36px;
  min-height: 36px;
  border-radius: 30px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  color: ${({ color, disabled }) =>
    disabled ? '#bfc3cb' : color || colors.textSecondary};
  white-space: nowrap;
  box-shadow: ${({ disabled }) =>
    disabled ? 'none' : '2px 2px 4px rgba(0, 0, 0, 0.25)'};
  opacity: ${({ disabled }) => (disabled ? 0.55 : 1)};
  overflow: hidden;

  &:hover {
    border-color: ${({ color, disabled }) =>
      disabled ? colors.border : color || colors.border};
    opacity: ${({ disabled }) => (disabled ? 0.55 : 0.75)};

    ${IconPillLabel} {
      color: #333333;
    }
  }

  img,
  svg {
    width: 16px;
    height: 16px;
    object-fit: contain;
    flex-shrink: 0;
  }

  i.icon {
    margin: 0 !important;
    line-height: 1;
  }
`;

const P = styled.p`
  color: rgba(0, 0, 0, 0.5);
  font-style: italic;
  margin: 0.7rem auto;
  max-width: 100%;
  line-height: 1.1rem;
  text-align: center;
`;

const Warning = styled.p`
  color: ${colors.red};
  font-weight: bold;
  position: absolute;
  top: 4.5rem;
  right: 2rem;
`;
